import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { GlobalErrorBoundary } from './utils/GlobalErrorBoundary.tsx';

if (import.meta.env.PROD) {
  // Console warning
  console.log(
    '%cHold Up!',
    'color: #ef4444; font-size: 50px; font-weight: bold; text-shadow: 2px 2px 0 #000, -2px -2px 0 #000, 2px -2px 0 #000, -2px 2px 0 #000;'
  );
  console.log(
    '%cThis is a browser feature intended for developers. Using this console may allow attackers to impersonate you and steal your information using an attack called Self-XSS. Do not enter or paste code that you do not understand.',
    'font-size: 16px; font-family: sans-serif; color: #a1a1aa;'
  );
}

const root = createRoot(document.getElementById('root')!);
root.render(
  <StrictMode>
    <GlobalErrorBoundary>
      <App />
    </GlobalErrorBoundary>
  </StrictMode>
);
